/**
 * @constructor
 * @param {number} win
 * @param {number} bet
 * @param {Array} winCoefs
 * @returns {BigWinCounter}
 */
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import events from "../../framework/src/events/EventsObservable";


export default function BigWinCounter(win, bet, winCoefs) {

    this._bigWinValue = winCoefs[0] * bet;
    this._megaWinValue = winCoefs[1] * bet;
    this._superWinValue = winCoefs[2] * bet;

    this._onUpdate = function (val) {};

    /** @type {Function} */
    this._onBigWin;
    /** @type {Function} */
    this._onMegaWin;
    /** @type {Function} */
    this._onSuperWin;

    this._anims = [];

    this._win = win;
    this._bet = bet;

    this._time = 10;

    /** @type {number} */
    this._intervalTicker;

    this.renderer = this._update.bind(this);

    /** @type {Function} */
    this.resolver;

    this.isBigWin = false;

    this._fps = 30;

    this.BIGWIN_TIME = 7.5;
    this.MEGAWIN_ACCELERATION = 0.1;
    this.SUPERMEGAWIN_ACCELERATION = 0.1;

    this._currVal = 0;

    this._step = 0.1;
}

BigWinCounter.prototype = {

    WIN_TYPES: {
        "bigwin": 0,
        "megawin": 1,
        "superwin": 2,
    },

    init: function () {
        this._bigWinFired = false;
        this._megaWinFired = false;
        this._superWinFired = false;

        this._anims = [];
    },

    _getType: function (win) {

        var type = this.WIN_TYPES["bigwin"];

        if (win >= this._superWinValue) {

            type = this.WIN_TYPES["superwin"];

        } else if (win >= this._megaWinValue) {

            type = this.WIN_TYPES["megawin"];

        }

        return type;
    },

    _update: function () {
        var type = this._getType(this._currVal);

        switch (type) {
            case this.WIN_TYPES["bigwin"]:

                if(this._getType(this._win) > this.WIN_TYPES["bigwin"]) {
                    this._currVal = (this._megaWinValue / this.BIGWIN_TIME) * this._step;
                } else {
                    this._currVal = (this._win / this.BIGWIN_TIME) * this._step;
                }

                if(!this._bigWinFired) {
                    this._bigWinFired = true;

                    this._onBigWin && this._anims.push(new Promise(this._onBigWin));
                }

                break;
            case this.WIN_TYPES["megawin"]:

                this._currVal =
                    (
                        (
                            ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp((this._step - (2 * this.BIGWIN_TIME)) * this.MEGAWIN_ACCELERATION) +
                            ((this._step - this.BIGWIN_TIME) / this.BIGWIN_TIME - 1) * ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp(-this.BIGWIN_TIME * this.MEGAWIN_ACCELERATION) +
                            (this._megaWinValue / this._bet)
                        ) * this._bet
                    );

                if(!this._megaWinFired) {
                    this._megaWinFired = true;
                    this._onMegaWin && this._anims.push(new Promise(this._onMegaWin));
                }

                break;
            case this.WIN_TYPES["superwin"]:
                this._currVal =
                    (
                        (
                            ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp((this._step - (2 * this.BIGWIN_TIME)) * this.SUPERMEGAWIN_ACCELERATION ) +
                            ((this._step - this.BIGWIN_TIME) / this.BIGWIN_TIME - 1) * ((this._superWinValue - this._megaWinValue) / this._bet) * Math.exp(-this.BIGWIN_TIME) +
                            (this._megaWinValue / this._bet)
                        ) * this._bet
                    );

                if(!this._superWinFired) {
                    this._superWinFired = true;
                    this._onSuperWin && this._anims.push(new Promise(this._onSuperWin));
                }

                break;
        }

        if (this._currVal < this._win) {
            this._onUpdate(this._currVal /*, this._getType()*/);
            this._step += 0.037;
        } else {
            this._onUpdate(this._win);
            this._end();
        }
    },

    _end: function () {

        var _self = this;

        //madnes_rem_from_render(this.renderer);
        clearInterval(this._intervalTicker);

        Promise.all(this._anims).then(function() {
            _self.resolver && _self.resolver();
            _self.resolver = null;
        });
    },

    run: function () {
        var _this = this;
        events.dispatch(GAME_EVENTS.GAME_BIGWIN);

        this.init();

        return new Promise(function (res) {
            _this.resolver = res;

            _this._intervalTicker = setInterval(_this.renderer, 1000 / _this._fps);

            //madnes_add_to_render(_this.renderer);

        });
    },

    stop: function (resolve) {
        if (resolve === false) {
            this.resolver = null;
        }

        this._end();
    },

    getCurVal: function () {
        return this._currVal;
    },

    onUpdate: function (func) {
        this._onUpdate = func;
    },

    onBigWin: function (func) {
        this._onBigWin = func;
    },

    onMegaWin: function (func) {
        this._onMegaWin = func;
    },

    onSuperWin: function (func) {
        this._onSuperWin = func;
    }
};